module.exports = __webpack_public_path__ + "img/Mississippi outline.041805b4.png";